import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-sign-on-verification',
  templateUrl: './single-sign-on-verification.component.html',
  styleUrls: ['./single-sign-on-verification.component.scss']
})
export class SingleSignOnVerificationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
